var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChalkboardOutline = function SvgChalkboardOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 3.99996H12.6667V11.3333H14V3.49996C14 3.04038 13.6263 2.66663 13.1667 2.66663H2.83337C2.37379 2.66663 2.00004 3.04038 2.00004 3.49996V11.3333H3.33337V3.99996ZM14.3334 12H11.3334V10.6666H7.33337V12H1.66671C1.48254 12 1.33337 12.1491 1.33337 12.3333V13C1.33337 13.1841 1.48254 13.3333 1.66671 13.3333H14.3334C14.5175 13.3333 14.6667 13.1841 14.6667 13V12.3333C14.6667 12.1491 14.5175 12 14.3334 12Z",
    fill: "#A1A4B1"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChalkboardOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chalkboard_outline.a8c62007.svg";
export { ForwardRef as ReactComponent };